import { Component } from "react";
import { connect } from "react-redux";
import actionCreators from "../../../store/Channels/Events/actionCreators";
import { default as mainMenuActionCreators } from "../../../store/MainMenu/actionCreators";
import { default as autocompleteActionCreators } from "../../../store/AutoComplete/actionCreators";
import Form from "./Form";
import currentFormTypes from "../../../common/components/CurrentFormTypes";
import initialEventValues from "../../../fixtures/ChannelEvent";
import { change } from "redux-form";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import formsCss from "../../../common/styles/forms.css";

class ChannelNewEventContainer extends Component {
    componentDidMount() {
        const {
            setTitle,
            match: {
                params: { id },
            },
            setCurrentFormType,
        } = this.props;
        const type = id ? currentFormTypes.EDIT : currentFormTypes.NEW;
        setCurrentFormType(type);
        setTitle("Channels \u203A Events Posts");
    }

    componentWillUnmount() {
        const { clearTitle } = this.props;
        clearTitle();
    }

    onSubmit = values => {
        const { postEvent } = this.props;
        postEvent({
            event: {
                ...values,
                imageFile:
                    values.imageFile && values.imageFile.base64 !== "" ? values.imageFile : null,
            },
        });
    };

    render() {
        const {
            currentFormType,
            initialValues,
            history: { goBack },
            channelPostTypes,
            hasDate,
            setDateFieldStatus,
            channels,
            getChannels,
            clearChannels,
            changeStartAt,
            changeEndAt,
            formValues,
            errorRes: { error, errors },
        } = this.props;
        const { onSubmit } = this;

        return (
            <div>
                <div css={formsCss.genericError}>{error}</div>
                <Form
                    initialValues={{
                        ...initialValues,
                        status: "draft",
                        channel:
                            this.props.history.location.state &&
                            !!this.props.history.location.state.id
                                ? this.props.history.location.state
                                : undefined,
                    }}
                    {...{
                        onSubmit,
                        currentFormType,
                        goBack,
                        hasDate,
                        setDateFieldStatus,
                        errors,
                        channels,
                        getChannels,
                        clearChannels,
                        changeStartAt,
                        changeEndAt,
                        formValues,
                    }}
                />
            </div>
        );
    }
}

const dispatchToProps = {
    setTitle: mainMenuActionCreators.setTitle.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    getOneEvent: actionCreators.getOneEvent.create,
    setCurrentFormType: actionCreators.setCurrentFormType.create,
    postEvent: actionCreators.postEvent.create,
    setDateFieldStatus: actionCreators.setDateFieldStatus.create,
    getChannels: autocompleteActionCreators.getChannels.create,
    clearChannels: autocompleteActionCreators.clearChannels.create,
    changeEndAt: newValue => change("Event", "endAt", newValue), // reset endAt value
    changeStartAt: newValue => change("Event", "startAt", newValue), // reset startAt value
};
const mapStateToProps = ({
    ChannelEvents: { errorRes, currentFormType, hasDate },
    AutoComplete: { channels },
    form: { Event },
}) => ({
    initialValues: initialEventValues,
    errorRes,
    currentFormType,
    hasDate,
    channels,
    formValues: Event,
});

export default connect(mapStateToProps, dispatchToProps)(ChannelNewEventContainer);
